/* eslint-disable */
//tslint:disable

export interface IVacancySchema {
  /** Дата и время создания вакансии **/
  created?: string | null;
  /** Дата создания в "человечном" виде **/
  createdHumanized?: string | null;
  /** Описание вакансии **/
  description: string;
  /** Email контакта вакансии **/
  email?: string | null;
  /** Тип занятости **/
  employment: EEmployment;
  /** ID вакансии в базе данных **/
  id?: number | null;
  /** Осталось до обновления в "человечном" виде **/
  leftToUpdate?: string | null;
  /** Верхняя граница вилки зарплат **/
  maxSalary?: number | null;
  /** Нижняя граница требуемого опыта **/
  minExperience?: number | null;
  /** Нижняя граница вилки зарплат **/
  minSalary?: number | null;
  /** Телефонный номер контакта вакансии (без "+7") **/
  phone?: string | null;
  /** Название региона вакансии **/
  regionDisplayName?: string | null;
  /** ID региона вакансии **/
  regionId: number;
  /** Специализация вакансии **/
  specialization: string;
  /** Дата и время обновления вакансии **/
  updated?: string | null;
  /** Дата обновления в "человечном" виде **/
  updatedHumanized?: string | null;
  userId?: number | null;
}

export enum EEmployment {
  /** Полная занятость **/
  Full = 'full',
  /** Частичная занятость **/
  Part = 'part',
  /** Сдельная оплата **/
  Piece = 'piece',
}
